import { createFileRoute } from '@tanstack/react-router';
import { QuietSettings } from '../../../features/B2b/QuietSettings';

/** Settings > "שעות שקט ותזמון" — lane B2b-web (quiet hours, test group, read-only pacing, staging allowlist). */
export const Route = createFileRoute('/_app/settings/quiet')({
  component: QuietSettings,
});
